import ConfiguracionService from "../services/ConfiguracionService";

const state = {};

const configuracion_service = new ConfiguracionService();

const actions = {
  async get_({
    commit
  }) {

    return new Promise((resolve, reject) => {

      configuracion_service.get()
        .then((result) => {
          resolve(result.data);
        }).catch(error => reject(error));

    });

  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};